window.MarketMapBuildingsMode = (function () {
    const BUILDING_TEXTURE_COUNT = 6;
    const BUILDING_TEXTURE_BASE = './desktop_assets/mmap-buildings/building-texture-';
    const GROUND_TEXTURE = './desktop_assets/mmap-buildings/road.jpg';
    const ROAD_MARKS_TEXTURE = './desktop_assets/mmap-buildings/road-marks.jpg';
    const SKY_TEXTURE = './desktop_assets/mmap-buildings/sky.jpg';
    const LOCATION_MODEL = './desktop_assets/mmap-buildings/location.glb';
    const BUILDINGS_LABEL_ALWAYS_TOP = 20;
    const BUILDINGS_LABEL_ANGULAR_THRESHOLD = 0.02;
    const MOUNTAINS_MODEL = './desktop_assets/mmap-buildings/mountains.glb';

    let _isActive = false;
    let _buildingEntities = [];
    let _groundPlane = null;
    let _skyEntity = null;
    let _savedSceneFog = null;
    let _mountainsEntity = null;
    let _savedContainerTransform = null;
    let _savedCameraState = null;
    let _wasFullscreenBefore = false;
    let _preloadedTextures = {};
    let _billboardRAF = null;
    let _fpsControls = null;
    let _worldBounds = null;
    let _roadEntities = [];
    let _sectorMarkerEntities = [];
    let _activeHologram = null;

    function _getVisualizer() {
        const el = document.getElementById('stock-3d-cube');
        return el && el.components && el.components['stock-cube-visualizer'];
    }

    function _getWrapper() {
        return document.getElementById('stock-3d-cube-wrapper');
    }

    function _randomTextureUrl() {
        const n = Math.floor(Math.random() * BUILDING_TEXTURE_COUNT) + 1;
        return BUILDING_TEXTURE_BASE + n + '-tile.jpg';
    }

    function _preloadTextures() {
        if (_preloadedTextures._done) return;
        var loader = new THREE.TextureLoader();
        for (var i = 1; i <= BUILDING_TEXTURE_COUNT; i++) {
            var url = BUILDING_TEXTURE_BASE + i + '-tile.jpg';
            loader.load(url);
        }
        loader.load(GROUND_TEXTURE);
        loader.load(ROAD_MARKS_TEXTURE);
        loader.load(SKY_TEXTURE);
        _preloadedTextures._done = true;
    }

    function isActive() {
        return _isActive;
    }

    function _startBillboardLoop() {
        function tick() {
            if (!_isActive) return;
            var cam = document.getElementById('camera');
            if (cam && cam.object3D) {
                var camWorldPos = new THREE.Vector3();
                cam.object3D.getWorldPosition(camWorldPos);
                var parentQuat = new THREE.Quaternion();
                var parentEuler = new THREE.Euler();
                var containerWorldScale = 1;
                var _vis = _getVisualizer();
                if (_vis && _vis.el && _vis.el.object3D) {
                    _vis.el.object3D.updateWorldMatrix(true, false);
                    containerWorldScale = _vis.el.object3D.matrixWorld.getMaxScaleOnAxis();
                }
                _buildingEntities.forEach(function (info) {
                    var lbl = info.label;
                    if (lbl && lbl.object3D && lbl.object3D.parent) {
                        var lblWorldPos = new THREE.Vector3();
                        lbl.object3D.getWorldPosition(lblWorldPos);
                        var dir = camWorldPos.clone().sub(lblWorldPos);
                        var targetY = Math.atan2(dir.x, dir.z);
                        lbl.object3D.parent.getWorldQuaternion(parentQuat);
                        parentEuler.setFromQuaternion(parentQuat, 'YXZ');
                        lbl.object3D.rotation.set(0, targetY - parentEuler.y, 0);

                        if (info._labelReady) {
                            if (info.alwaysVisible) {
                                lbl.object3D.visible = true;
                            } else {
                                var dist = lblWorldPos.distanceTo(camWorldPos);
                                var worldWidth = info.bldWidth * containerWorldScale;
                                lbl.object3D.visible = dist < 0.001 || (worldWidth / dist) >= BUILDINGS_LABEL_ANGULAR_THRESHOLD;
                            }
                        }
                    }
                });
                _sectorMarkerEntities.forEach(function (marker) {
                    if (!marker || !marker.object3D) return;
                    var lbl = marker.querySelector('a-troika-text');
                    if (!lbl || !lbl.object3D) return;
                    var lblWorldPos = new THREE.Vector3();
                    lbl.object3D.getWorldPosition(lblWorldPos);
                    var dir = camWorldPos.clone().sub(lblWorldPos);
                    var targetY = Math.atan2(dir.x, dir.z);
                    marker.object3D.getWorldQuaternion(parentQuat);
                    parentEuler.setFromQuaternion(parentQuat, 'YXZ');
                    lbl.object3D.rotation.set(0, targetY - parentEuler.y, 0);
                });

                if (_activeHologram && _activeHologram.object3D) {
                    var holoPos = new THREE.Vector3();
                    _activeHologram.object3D.getWorldPosition(holoPos);
                    var dir2 = camWorldPos.clone().sub(holoPos);
                    var targetY2 = Math.atan2(dir2.x, dir2.z);
                    _activeHologram.object3D.rotation.set(0, targetY2, 0);
                }
            }
            _billboardRAF = requestAnimationFrame(tick);
        }
        _billboardRAF = requestAnimationFrame(tick);
    }

    function _stopBillboardLoop() {
        if (_billboardRAF) {
            cancelAnimationFrame(_billboardRAF);
            _billboardRAF = null;
        }
    }

    function enter() {
        if (_isActive) return;

        const visualizer = _getVisualizer();
        if (!visualizer) { console.warn('[Buildings] No visualizer'); return; }
        if (visualizer.mmapViewMode !== '2d') { console.warn('[Buildings] Only available in 2D mode'); return; }
        if (!visualizer.stockBars || visualizer.stockBars.size === 0) {
            console.warn('[Buildings] No stock bars to transform');
            return;
        }

        _isActive = true;

        const wrapper = _getWrapper();
        const containerEl = document.getElementById('center-panel-container');
        const camera = document.getElementById('camera');

        if (wrapper) {
            _savedWrapperTransform = {
                position: wrapper.getAttribute('position'),
                rotation: wrapper.getAttribute('rotation'),
                scale: wrapper.getAttribute('scale')
            };
        }
        if (containerEl) {
            _savedContainerTransform = {
                position: containerEl.getAttribute('position')
            };
        }
        if (camera) {
            _savedCameraState = {
                position: camera.getAttribute('position'),
                fov: camera.getAttribute('camera') && camera.getAttribute('camera').fov
            };
        }

        _wasFullscreenBefore = document.body.classList.contains('chart-fullscreen');
        if (!_wasFullscreenBefore) {
            const fullscreenToggle = document.querySelector('#main-block .fullscreen-toggle');
            if (fullscreenToggle) fullscreenToggle.click();
        }

        requestAnimationFrame(function () {
            document.body.classList.add('mmap-buildings-active');
        });

        if (containerEl && containerEl.object3D) {
            gsap.to(containerEl.object3D.position, {
                x: 0,
                y: 2.2,
                z: -1.0,
                duration: 1.0,
                ease: 'power2.inOut'
            });
        }

        if (camera && camera.object3D) {
            gsap.to(camera.object3D.position, {
                x: -4.00,
                y: 3.11,
                z: 4.57,
                duration: 1.2,
                ease: 'power2.inOut'
            });
        }

        if (wrapper && wrapper.object3D) {
            gsap.to(wrapper.object3D.position, {
                x: 0, y: 0, z: 0,
                duration: 1.0,
                ease: 'power2.inOut'
            });
            gsap.to(wrapper.object3D.rotation, {
                x: 0, y: THREE.MathUtils.degToRad(20), z: 0,
                duration: 1.2,
                ease: 'power3.inOut'
            });
            gsap.to(wrapper.object3D.scale, {
                x: 1.6, y: 1.6, z: 1.6,
                duration: 1.0,
                ease: 'power2.inOut'
            });
        }

        _preloadTextures();

        const panelLight = document.querySelector('#large-center-panel a-light');
        if (panelLight) panelLight.setAttribute('visible', false);

        _hideSectorPlatforms(visualizer);

        _fadeOutAllBars(visualizer);

        _transformBarsToBuildings(visualizer);

        _startBillboardLoop();

        _createSkybox();

        setTimeout(function () { _createFPSControls(); }, 1300);

        const sceneEl = document.querySelector('a-scene');
        if (sceneEl) sceneEl.emit('mmap-buildings-entered');
    }

    function exit() {
        if (!_isActive) return;
        _isActive = false;

        _hideHologramPopup();

        _stopBillboardLoop();

        _destroyFPSControls();

        document.body.classList.remove('mmap-buildings-active');

        const visualizer = _getVisualizer();
        const wrapper = _getWrapper();
        const camera = document.getElementById('camera');
        const containerEl = document.getElementById('center-panel-container');

        _buildingEntities.forEach(function (info) {
            if (!info.building || !info.building.parentNode) return;
            const obj = info.building.object3D;
            if (!obj) return;
            gsap.to(obj.scale, {
                y: 0.001,
                duration: 0.5,
                ease: 'power2.in',
                onComplete: function () {
                    if (info.building.parentNode) info.building.parentNode.removeChild(info.building);
                }
            });
        });
        _buildingEntities = [];

        if (containerEl && containerEl.object3D && _savedContainerTransform) {
            var cp = _savedContainerTransform.position;
            if (cp) {
                containerEl.object3D.position.set(
                    typeof cp.x === 'number' ? cp.x : (parseFloat(String(cp).split(' ')[0]) || 0),
                    typeof cp.y === 'number' ? cp.y : (parseFloat(String(cp).split(' ')[1]) || 2.7),
                    typeof cp.z === 'number' ? cp.z : (parseFloat(String(cp).split(' ')[2]) || -1.2)
                );
            }
        }

        if (camera && camera.object3D && _savedCameraState) {
            var scp = _savedCameraState.position;
            if (scp) {
                camera.object3D.position.set(
                    typeof scp.x === 'number' ? scp.x : 0,
                    typeof scp.y === 'number' ? scp.y : 2.75,
                    typeof scp.z === 'number' ? scp.z : 2
                );
            }
        }

        _roadEntities.forEach(function (road) {
            if (road && road.parentNode) road.parentNode.removeChild(road);
        });
        _roadEntities = [];

        _sectorMarkerEntities.forEach(function (marker) {
            if (marker && marker.parentNode) marker.parentNode.removeChild(marker);
        });
        _sectorMarkerEntities = [];

        if (_groundPlane && _groundPlane.parentNode) {
            _groundPlane.parentNode.removeChild(_groundPlane);
        }
        _groundPlane = null;

        _removeSkybox();

        const panelLight = document.querySelector('#large-center-panel a-light');
        if (panelLight) panelLight.setAttribute('visible', true);

        _restoreSectorPlatforms(visualizer);

        if (visualizer && visualizer.stockBars) {
            visualizer.stockBars.forEach(function (info) {
                if (info.bar) {
                    if (info.bar.object3D) {
                        gsap.killTweensOf(info.bar.object3D.scale);
                        info.bar.object3D.scale.set(1, 1, 1);
                    }
                    info.bar.setAttribute('visible', true);
                    var lbl = info.bar.querySelector('a-troika-text');
                    if (lbl) lbl.setAttribute('visible', true);
                }
            });
        }

        _resetTo2DPosition(visualizer, wrapper);

        if (!_wasFullscreenBefore) {
            setTimeout(function () {
                var closeBtn = document.querySelector('#main-block .fullscreen-close');
                if (closeBtn) closeBtn.click();
            }, 600);
        }

        _savedWrapperTransform = null;
        _savedContainerTransform = null;
        _savedCameraState = null;

        var sceneEl = document.querySelector('a-scene');
        if (sceneEl) sceneEl.emit('mmap-buildings-exited');
    }

    function _createSkybox() {
        var sceneEl = document.querySelector('a-scene');
        if (!sceneEl) return;

        _savedSceneBackground = sceneEl.getAttribute('background');
        _savedSceneFog = sceneEl.getAttribute('fog');

        sceneEl.setAttribute('fog', {
            type: 'exponential',
            color: '#b0c4de',
            density: 0.08
        });
        
        var sky = document.createElement('a-sky');
        sky.setAttribute('src', SKY_TEXTURE);
        sky.setAttribute('rotation', '0 -90 0');
        sky.classList.add('mmap-buildings-sky');
        sceneEl.appendChild(sky);
        _skyEntity = sky;

        sky.addEventListener('materialtextureloaded', function () {
            var mesh = sky.getObject3D('mesh');
            if (mesh && mesh.material) {
                mesh.material.fog = false;
                mesh.material.needsUpdate = true;
            }
        });
        
        // mountains
        const mountains = document.createElement('a-entity');
        mountains.classList.add('mmap-buildings-mountains');
        mountains.setAttribute('gltf-model', MOUNTAINS_MODEL);
        mountains.setAttribute('scale', '1 1 1');
        mountains.setAttribute('position', '-2 1.5 -4');
        mountains.setAttribute('rotation', '0 45 0');
        sceneEl.appendChild(mountains);
        _mountainsEntity = mountains;
    }

    function _removeSkybox() {
        var sceneEl = document.querySelector('a-scene');

        if (_skyEntity && _skyEntity.parentNode) {
            _skyEntity.parentNode.removeChild(_skyEntity);
        }
        _skyEntity = null;
        
        if (_mountainsEntity && _mountainsEntity.parentNode) {
            _mountainsEntity.parentNode.removeChild(_mountainsEntity);
        }
        _mountainsEntity = null;
        
        if (sceneEl) {
            if (_savedSceneFog) {
                sceneEl.setAttribute('fog', _savedSceneFog);
            } else {
                sceneEl.removeAttribute('fog');
            }
        }
        _savedSceneFog = null;
        _savedSceneBackground = null;
    }

    function _hideSectorPlatforms(visualizer) {
        if (!visualizer) return;
        var el = visualizer.el;
        var bgPlatform = el.querySelector('#background-platform');
        if (bgPlatform) bgPlatform.setAttribute('visible', false);
        if (visualizer.sectorPlatforms) {
            visualizer.sectorPlatforms.forEach(function (platform) {
                var bgEl = platform && platform.bg ? platform.bg : platform;
                if (bgEl && typeof bgEl.setAttribute === 'function') bgEl.setAttribute('visible', false);
                if (platform && platform.label && typeof platform.label.setAttribute === 'function') platform.label.setAttribute('visible', false);
            });
        }
        if (visualizer.sectorLabels) {
            visualizer.sectorLabels.forEach(function (lbl) {
                if (lbl) lbl.setAttribute('visible', false);
            });
        }
        var borderMaps = ['sectorLeftBorders', 'sectorRightBorders', 'sectorTopBorders', 'sectorBottomBorders'];
        borderMaps.forEach(function (mapName) {
            if (visualizer[mapName]) {
                visualizer[mapName].forEach(function (border) {
                    if (border) border.setAttribute('visible', false);
                });
            }
        });
        el.querySelectorAll(':scope > a-plane').forEach(function (p) {
            if (!p.classList.contains('mmap-building') && !p.classList.contains('mmap-building-ground')) {
                p.setAttribute('visible', false);
                p._buildingsHidden = true;
            }
        });
        el.querySelectorAll(':scope > a-text').forEach(function (t) {
            t.setAttribute('visible', false);
            t._buildingsHidden = true;
        });
    }

    function _restoreSectorPlatforms(visualizer) {
        if (!visualizer) return;
        var el = visualizer.el;
        var bgPlatform = el.querySelector('#background-platform');
        if (bgPlatform) bgPlatform.setAttribute('visible', true);
        if (visualizer.sectorPlatforms) {
            visualizer.sectorPlatforms.forEach(function (platform) {
                var bgEl = platform && platform.bg ? platform.bg : platform;
                if (bgEl && typeof bgEl.setAttribute === 'function') bgEl.setAttribute('visible', true);
                if (platform && platform.label && typeof platform.label.setAttribute === 'function') platform.label.setAttribute('visible', true);
            });
        }
        if (visualizer.sectorLabels) {
            visualizer.sectorLabels.forEach(function (lbl) {
                if (lbl) lbl.setAttribute('visible', true);
            });
        }
        var borderMaps = ['sectorLeftBorders', 'sectorRightBorders', 'sectorTopBorders', 'sectorBottomBorders'];
        borderMaps.forEach(function (mapName) {
            if (visualizer[mapName]) {
                visualizer[mapName].forEach(function (border) {
                    if (border) border.setAttribute('visible', true);
                });
            }
        });
        el.querySelectorAll(':scope > a-plane').forEach(function (p) {
            if (p._buildingsHidden) {
                p.setAttribute('visible', true);
                delete p._buildingsHidden;
            }
        });
        el.querySelectorAll(':scope > a-text').forEach(function (t) {
            if (t._buildingsHidden) {
                t.setAttribute('visible', true);
                delete t._buildingsHidden;
            }
        });
    }

    function _fadeOutAllBars(visualizer) {
        if (!visualizer || !visualizer.stockBars) return;
        visualizer.stockBars.forEach(function (info) {
            if (!info.bar || !info.bar.object3D) return;
            info.bar.object3D.scale.set(0.001, 0.001, 0.001);
            info.bar.setAttribute('visible', false);
        });
    }

    function _hideHologramPopup() {
        if (_activeHologram && _activeHologram.parentNode) {
            _activeHologram.parentNode.removeChild(_activeHologram);
        }
        _activeHologram = null;
    }

    function _formatLargeNumber(num) {
        if (!Number.isFinite(num)) return '0';
        var absNum = Math.abs(num);
        if (absNum >= 1.0e+12) return (num / 1.0e+12).toFixed(1) + ' T';
        if (absNum >= 1.0e+9) return (num / 1.0e+9).toFixed(1) + ' B';
        if (absNum >= 1.0e+6) return (num / 1.0e+6).toFixed(1) + ' M';
        if (absNum >= 1.0e+3) return (num / 1.0e+3).toFixed(1) + ' K';
        return num.toFixed(2);
    }

    function _showHologramPopup(info) {
        _hideHologramPopup();

        var sceneEl = document.querySelector('a-scene');
        if (!sceneEl) return;

        var hologram = document.createElement('a-entity');
        _activeHologram = hologram;
        hologram.classList.add('hologram-popup');

        var building = info.building;
        var stock = info.stock;
        
        var bbox = new THREE.Box3().setFromObject(building.object3D);
        var topY = bbox.max.y;
        
        var worldPos = new THREE.Vector3();
        building.object3D.getWorldPosition(worldPos);
        
        var hY = Math.max(topY + 0.15, worldPos.y + 0.35);
        hologram.setAttribute('position', worldPos.x + ' ' + hY + ' ' + worldPos.z);
        
        var popup = document.createElement('a-rounded-plane');
        popup.setAttribute('id', 'stock-popup');
        popup.setAttribute('scale', '0.4 0.4 0.4');
        popup.setAttribute('width', '1.5');
        popup.setAttribute('height', '0.66');
        popup.setAttribute('radius', '0.05');
        popup.setAttribute('color', '#14141C');
        
        popup.setAttribute('position', '-0.3 -0.132 0');

        hologram.appendChild(popup);

        var name = stock.tickerDetails && stock.tickerDetails.name ? stock.tickerDetails.name : (stock.tickerSummary && stock.tickerSummary.name ? stock.tickerSummary.name : (stock.ticker || 'UNKNOWN'));
        var exchange = stock.tickerDetails && stock.tickerDetails.primary_exchange ? stock.tickerDetails.primary_exchange : (stock.tickerSummary && stock.tickerSummary.primary_exchange ? stock.tickerSummary.primary_exchange : (stock.primary_exchange || 'Unknown Exchange'));
        if (exchange === "New York Stock Exchange") exchange = "NYSE";
        
        var price = stock.day && stock.day.c ? stock.day.c : stock.price || 0;
        var volume = stock.day && stock.day.v ? stock.day.v : stock.volume || 0;
        var changePerc = (stock.todaysChangePerc || 0).toFixed(1) + '%';
        
        var priceParts = price.toFixed(2).split('.');
        var formattedPrice = '$' + priceParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '.' + (priceParts[1] || '00');
        
        var mktCap = stock.market_cap || (stock.tickerSummary && stock.tickerSummary.market_cap) || (stock.tickerDetails && stock.tickerDetails.market_cap) || 0;
        var formattedCap = '$' + _formatLargeNumber(mktCap);

        var extraRowsCount = 2;
        var extraLabels = 'Volume:\nMkt Cap:\n';
        var extraValues = _formatLargeNumber(volume) + '\n' + formattedCap + '\n';

        var labelsBaseY = 0.37;
        var companyBaseY = 0.45;
        var deltaH = extraRowsCount * 0.07;
        var shift = deltaH / 2;

        var labels = document.createElement('a-text');
        labels.setAttribute('value',
            'Ticker:\n' +
            'Exchange:\n' +
            'Change:\n' +
            'Price:\n' +
            extraLabels
        );
        labels.setAttribute('position', '0.5 ' + (labelsBaseY + shift) + ' 0.02');
        labels.setAttribute('align', 'right');
        labels.setAttribute('baseline', 'top');
        labels.setAttribute('color', '#FFFFFF');
        labels.setAttribute('opacity', '0.5');
        labels.setAttribute('scale', '0.7 0.7 0.7');
        labels.setAttribute('width', '2.1');
        labels.setAttribute('shader', 'msdf');
        labels.setAttribute('font', 'roboto');
        labels.setAttribute('negate', 'true');
        labels.setAttribute('alphaTest', '0.5');
        popup.appendChild(labels);

        var values = document.createElement('a-text');
        values.setAttribute('value',
            (stock.ticker || 'UNKNOWN') + '\n' +
            exchange + '\n' +
            changePerc + '\n' +
            formattedPrice + '\n' +
            extraValues
        );
        values.setAttribute('position', '0.6 ' + (labelsBaseY + shift) + ' 0.02');
        values.setAttribute('align', 'left');
        values.setAttribute('baseline', 'top');
        values.setAttribute('color', '#FFFFFF');
        values.setAttribute('scale', '0.7 0.7 0.7');
        values.setAttribute('width', '2.1');
        values.setAttribute('shader', 'msdf');
        values.setAttribute('font', 'roboto');
        values.setAttribute('negate', 'true');
        values.setAttribute('alphaTest', '0.5');
        popup.appendChild(values);

        var companyname = document.createElement('a-text');
        companyname.setAttribute('value', name + '\n');
        companyname.setAttribute('position', '0.35 ' + (companyBaseY + shift) + ' 0.01');
        companyname.setAttribute('align', 'left');
        companyname.setAttribute('color', '#FFFFFF');
        companyname.setAttribute('scale', '0.7 0.7 0.7');
        companyname.setAttribute('width', '2.3');
        companyname.setAttribute('shader', 'msdf');
        companyname.setAttribute('font', 'roboto');
        companyname.setAttribute('negate', 'true');
        companyname.setAttribute('alphaTest', '0.5');
        popup.appendChild(companyname);

        sceneEl.appendChild(hologram);
    }

    function _percToOutlineColor(perc) {
        if (Math.abs(perc) < 0.05) return null;
        return perc > 0 ? '#00EE55' : '#FF2200';
    }

    function _transformBarsToBuildings(visualizer) {
        _buildingEntities = [];

        var stockEntries = [];
        visualizer.stockBars.forEach(function (info, ticker) {
            stockEntries.push({ ticker: ticker, info: info });
        });

        if (stockEntries.length === 0) return;

        var maxMarketCap = 0;
        stockEntries.forEach(function (entry) {
            var mc = (entry.info.stock && entry.info.stock.market_cap) || 0;
            if (mc > maxMarketCap) maxMarketCap = mc;
        });
        if (maxMarketCap <= 0) maxMarketCap = 1;

        var minBuildingWidth = window.MMAP_BLDG_MIN_WIDTH;
        var maxBuildingWidth = window.MMAP_BLDG_MAX_WIDTH;

        var meanHeight    = window.MMAP_BLDG_MEAN_HEIGHT;
        var maxHeightDiff = window.MMAP_BLDG_MAX_HDIFF;
        var maxAbsPerc = 0;
        stockEntries.forEach(function (entry) {
            var p = Math.abs((entry.info.stock && entry.info.stock.todaysChangePerc) || 0);
            if (p > maxAbsPerc) maxAbsPerc = p;
        });
        if (maxAbsPerc <= 0) maxAbsPerc = 1;

        var container = visualizer.el;

        var sectorMap = {};
        stockEntries.forEach(function (entry) {
            var sid = (entry.info.stock && entry.info.stock.sector_id) || 'unknown';
            if (!sectorMap[sid]) sectorMap[sid] = [];
            
            var marketCap   = (entry.info.stock && entry.info.stock.market_cap) || 0;
            var capRatio    = Math.sqrt(marketCap / maxMarketCap);
            entry.bldWidth  = minBuildingWidth + capRatio * (maxBuildingWidth - minBuildingWidth);

            sectorMap[sid].push(entry);
        });
        var sectorIds = Object.keys(sectorMap);

        sectorIds.forEach(function (sid) {
            sectorMap[sid].sort(function (a, b) {
                return ((b.info.stock && b.info.stock.market_cap) || 0) -
                       ((a.info.stock && a.info.stock.market_cap) || 0);
            });
        });

        var innerGap = window.MMAP_BLDG_MIN_WIDTH * window.MMAP_BLDG_INNER_GAP;
        var blockGap = maxBuildingWidth * window.MMAP_BLDG_SECTOR_GAP;

        var blockCols = Math.ceil(Math.sqrt(sectorIds.length * 1.4));
        if (blockCols === 0) blockCols = 1;
        var blockRows = Math.ceil(sectorIds.length / blockCols);

        var globalColWidths = new Array(blockCols).fill(0);
        var globalRowDepths = new Array(blockRows).fill(0);

        sectorIds.forEach(function(sid, idx) {
            var entries = sectorMap[sid];
            var cols = Math.ceil(Math.sqrt(entries.length));
            if (cols === 0) cols = 1;
            var rows = Math.ceil(entries.length / cols);

            var colWidths = new Array(cols).fill(0);
            var rowDepths = new Array(rows).fill(0);

            entries.forEach(function(entry, eIdx) {
                var c = eIdx % cols;
                var r = Math.floor(eIdx / cols);
                if (entry.bldWidth > colWidths[c]) colWidths[c] = entry.bldWidth;
                if (entry.bldWidth > rowDepths[r]) rowDepths[r] = entry.bldWidth;
            });

            var sectorW = colWidths.reduce(function(a, b) { return a + b; }, 0) + (cols - 1) * innerGap;
            var sectorD = rowDepths.reduce(function(a, b) { return a + b; }, 0) + (rows - 1) * innerGap;

            entries.layout = {
                cols: cols, rows: rows,
                colWidths: colWidths, rowDepths: rowDepths,
                width: sectorW, depth: sectorD
            };

            var gC = idx % blockCols;
            var gR = Math.floor(idx / blockCols);
            if (sectorW > globalColWidths[gC]) globalColWidths[gC] = sectorW;
            if (sectorD > globalRowDepths[gR]) globalRowDepths[gR] = sectorD;
        });

        var totalWidth = globalColWidths.reduce(function(a, b) { return a + b; }, 0) + (blockCols - 1) * blockGap;
        var totalDepth = globalRowDepths.reduce(function(a, b) { return a + b; }, 0) + (blockRows - 1) * blockGap;

        var globalColX = new Array(blockCols);
        var currX = -totalWidth / 2;
        for (var c = 0; c < blockCols; c++) {
            globalColX[c] = currX;
            currX += globalColWidths[c] + blockGap;
        }

        var globalRowZ = new Array(blockRows);
        var currZ = -totalDepth / 2;
        for (var r = 0; r < blockRows; r++) {
            globalRowZ[r] = currZ;
            currZ += globalRowDepths[r] + blockGap;
        }

        var globalIdx = 0;

        sectorIds.forEach(function (sid, sectorIdx) {
            var entries = sectorMap[sid];
            var bCol = sectorIdx % blockCols;
            var bRow = Math.floor(sectorIdx / blockCols);

            var layout = entries.layout;
            
            var cellStartX = globalColX[bCol];
            var cellStartZ = globalRowZ[bRow];
            
            var sumColWidths = layout.colWidths.reduce(function(a, b) { return a + b; }, 0);
            var sumRowDepths = layout.rowDepths.reduce(function(a, b) { return a + b; }, 0);

            var localInnerGapX = layout.cols > 1 ? (globalColWidths[bCol] - sumColWidths) / (layout.cols - 1) : innerGap;
            var localInnerGapZ = layout.rows > 1 ? (globalRowDepths[bRow] - sumRowDepths) / (layout.rows - 1) : innerGap;

            var sectorStartX = cellStartX;
            if (layout.cols === 1) sectorStartX += (globalColWidths[bCol] - sumColWidths) / 2;

            var sectorStartZ = cellStartZ;
            if (layout.rows === 1) sectorStartZ += (globalRowDepths[bRow] - sumRowDepths) / 2;

            var colX = new Array(layout.cols);
            var lx = sectorStartX;
            for (var c = 0; c < layout.cols; c++) {
                colX[c] = lx + layout.colWidths[c] / 2;
                lx += layout.colWidths[c] + localInnerGapX;
            }

            var rowZ = new Array(layout.rows);
            var lz = sectorStartZ;
            for (var r = 0; r < layout.rows; r++) {
                rowZ[r] = lz + layout.rowDepths[r] / 2;
                lz += layout.rowDepths[r] + localInnerGapZ;
            }

            entries.forEach(function (entry, localIdx) {
                var info  = entry.info;
                var stock = info.stock;
                var bar   = info.bar;
                if (!bar || !bar.object3D) return;

                var bldWidth    = entry.bldWidth;
                var perc        = (stock && stock.todaysChangePerc) || 0;
                var percRatio   = perc / maxAbsPerc; // -1..1
                var finalHeight = Math.max(0.01, meanHeight + percRatio * maxHeightDiff);

                var lCol    = localIdx % layout.cols;
                var lRow    = Math.floor(localIdx / layout.cols);
                var targetX = colX[lCol];
                var targetZ = rowZ[lRow];

                var building = document.createElement('a-box');
                building.setAttribute('width',  bldWidth);
                building.setAttribute('depth',  bldWidth);
                building.setAttribute('height', meanHeight);
                building.setAttribute('position', targetX + ' ' + (meanHeight / 2) + ' ' + targetZ);

                var barColor = visualizer.getGradientColor(perc);

                var textureUrl = _randomTextureUrl();
                var repY = Math.max(1, Math.round(finalHeight / bldWidth));

                building.setAttribute('material', {
                    src: textureUrl,
                    repeat: '1 ' + repY,
                    color: '#FFFFFF',
                    transparent: false,
                    side: 'double',
                    depthTest: true,
                    depthWrite: true
                });

                building.addEventListener('materialtextureloaded', function onTexLoaded() {
                    building.removeEventListener('materialtextureloaded', onTexLoaded);
                    var mesh = building.getObject3D('mesh');
                    if (!mesh || !mesh.material || !mesh.material.map) return;
                    var tex = mesh.material.map;
                    tex.wrapS = THREE.RepeatWrapping;
                    tex.wrapT = THREE.RepeatWrapping;
                    tex.repeat.set(1, repY);
                    tex.needsUpdate = true;
                    mesh.material.needsUpdate = true;
                });

                building.setAttribute('data-raycastable', '');
                building.setAttribute('class', 'mmap-building');

                building.setAttribute('stock-bar', {
                    stockData: JSON.stringify(stock),
                    baseColor: barColor
                });

                container.appendChild(building);

                var label = document.createElement('a-troika-text');
                var pct = typeof perc === 'number' ? '\n' + perc.toFixed(1) + '%' : '';
                label.setAttribute('value', (stock.ticker || stock.name || '') + pct);
                label.setAttribute('align', 'center');
                label.setAttribute('anchor', 'center');
                label.setAttribute('color', '#FFFFFF');
                label.setAttribute('outline-width', '12%');
                label.setAttribute('outline-blur', '15%');
                label.setAttribute('outline-color', '#000000');
                label.setAttribute('fill-opacity', '1.0');
                label.setAttribute('opacity', '0');
                label.setAttribute('font-size', '0.016');
                label.setAttribute('position', '0 ' + (meanHeight / 2 + 0.025 * meanHeight / Math.max(finalHeight, 0.01)) + ' 0');
                label.setAttribute('rotation', '0 0 0');
                label.classList.add('billboard-y');
                building.appendChild(label);

                var outlineColor = _percToOutlineColor(perc);
                if (outlineColor) {
                    var outlineEl = document.createElement('a-box');
                    outlineEl.setAttribute('width',  bldWidth * 1.07);
                    outlineEl.setAttribute('depth',  bldWidth * 1.07);
                    outlineEl.setAttribute('height', meanHeight);
                    outlineEl.setAttribute('position', '0 0 0');
                    outlineEl.setAttribute('material', {
                        color: outlineColor,
                        emissive: outlineColor,
                        emissiveIntensity: 1.0,
                        shader: 'flat',
                        side: 'back',
                        transparent: false,
                        depthTest: true,
                        depthWrite: true
                    });
                    building.appendChild(outlineEl);
                }

                var entityInfo = {
                    building: building,
                    label: label,
                    targetHeight: finalHeight,
                    stock: stock,
                    bldWidth: bldWidth,
                    alwaysVisible: false,
                    _labelReady: false
                };
                _buildingEntities.push(entityInfo);

                var delay = globalIdx * 0.018;
                globalIdx++;

                (function (bld, lbl, fH, mH, bW, d, entInfo) {
                    bld.addEventListener('loaded', function onLoaded() {
                        bld.removeEventListener('loaded', onLoaded);
                        var obj3d = bld.object3D;
                        if (!obj3d) return;

                        obj3d.scale.set(1, 1, 1);
                        obj3d.position.y = mH / 2;

                        var scaleTarget = fH / mH;
                        gsap.to(obj3d.scale, {
                            y: scaleTarget,
                            duration: 0.8,
                            delay: d,
                            ease: fH >= mH ? 'power2.out' : 'power2.in',
                            onUpdate: function () {
                                obj3d.position.y = mH * obj3d.scale.y / 2;
                            },
                            onComplete: function () {
                                lbl.setAttribute('opacity', '1');
                                lbl.setAttribute('position', '0 ' + (mH / 2 + 0.025 * mH / Math.max(fH, 0.01)) + ' 0');
                                entInfo._labelReady = true;
                            }
                        });
                    });
                })(building, label, finalHeight, meanHeight, bldWidth, delay, entityInfo);
            });
        });

        _sectorMarkerEntities = [];
        var markerScale = maxBuildingWidth * 0.4;
        var sectorFullNames = {
            1: 'Utilities', 2: 'Energy', 3: 'Materials', 4: 'Financials',
            5: 'Healthcare', 6: 'Real Estate', 7: 'Technology',
            8: 'Industrials', 9: 'Communication Services',
            10: 'Consumer Staples', 11: 'Consumer Discretionary'
        };
        var sectorNames = (visualizer && visualizer.sectorNames) || {};
        sectorIds.forEach(function (sid, sectorIdx) {
            var bCol = sectorIdx % blockCols;
            var bRow = Math.floor(sectorIdx / blockCols);

            var blockCenterX = globalColX[bCol] + globalColWidths[bCol] / 2;

            var frontZ = globalRowZ[bRow] + globalRowDepths[bRow] + blockGap * 0.35;

            var marker = document.createElement('a-entity');
            marker.setAttribute('gltf-model', LOCATION_MODEL);
            marker.setAttribute('position', blockCenterX + ' 0 ' + frontZ);
            marker.setAttribute('scale', markerScale + ' ' + markerScale + ' ' + markerScale);
            marker.setAttribute('class', 'mmap-building-sector-marker');
            container.appendChild(marker);

            var sectorLabel = document.createElement('a-troika-text');
            var displayName = sectorFullNames[sid] || sectorNames[sid] || String(sid);
            sectorLabel.setAttribute('value', displayName);
            sectorLabel.setAttribute('align', 'center');
            sectorLabel.setAttribute('anchor', 'center');
            sectorLabel.setAttribute('color', '#FFFFFF');
            sectorLabel.setAttribute('outline-width', '12%');
            sectorLabel.setAttribute('outline-blur', '15%');
            sectorLabel.setAttribute('outline-color', '#000000');
            sectorLabel.setAttribute('fill-opacity', '1.0');
            sectorLabel.setAttribute('font-size', '0.5');
            sectorLabel.setAttribute('position', '0 2.5 0');
            sectorLabel.classList.add('billboard-y');
            marker.appendChild(sectorLabel);

            _sectorMarkerEntities.push(marker);
        });

        var groundSize = Math.max(totalWidth, totalDepth) * 4 + 2;
        var ground = document.createElement('a-plane');
        ground.setAttribute('width', groundSize);
        ground.setAttribute('height', groundSize);
        ground.setAttribute('rotation', '-90 0 0');
        ground.setAttribute('position', '0 -0.001 0');
        var groundRepeat = Math.max(4, Math.round(groundSize / 0.1));
        ground.setAttribute('material', {
            src: GROUND_TEXTURE,
            color: '#FFFFFF',
            repeat: groundRepeat + ' ' + groundRepeat,
            side: 'double',
            depthTest: true,
            depthWrite: true,
            shader: 'flat'
        });
        ground.setAttribute('class', 'mmap-building-ground');
        container.appendChild(ground);
        _groundPlane = ground;

        _worldBounds = {
            halfSize: groundSize / 2,
            maxHeight: (meanHeight + maxHeightDiff) + 0.1,
            minHeight: 0.02
        };

        _roadEntities = [];
        var roadWidth = blockGap * 0.85;

        var vRoadXPositions = [];
        for (var col = 0; col < blockCols - 1; col++) {
            var roadX = globalColX[col + 1] - blockGap / 2;
            vRoadXPositions.push(roadX);
        }

        var avgBlockDepth = totalDepth / blockRows;
        var vRoadLength = totalDepth + avgBlockDepth + roadWidth;
        var vRoadRepeatY = Math.max(1, Math.round(vRoadLength / roadWidth));
        vRoadXPositions.forEach(function (roadX) {
            var vRoad = document.createElement('a-plane');
            vRoad.setAttribute('width', roadWidth);
            vRoad.setAttribute('height', vRoadLength);
            vRoad.setAttribute('rotation', '-90 0 0');
            vRoad.setAttribute('position', roadX + ' 0.002 0');
            vRoad.setAttribute('material', {
                src: ROAD_MARKS_TEXTURE,
                color: '#FFFFFF',
                repeat: '1 ' + vRoadRepeatY,
                transparent: true,
                side: 'double',
                depthTest: true,
                depthWrite: false
            });
            vRoad.setAttribute('class', 'mmap-building-road');
            container.appendChild(vRoad);
            _roadEntities.push(vRoad);
        });

        var avgBlockWidth = totalWidth / blockCols;
        var hFullLeft  = -(totalWidth / 2 + avgBlockWidth / 2 + roadWidth / 2);
        var hFullRight =  (totalWidth / 2 + avgBlockWidth / 2 + roadWidth / 2);

        for (var row = 0; row < blockRows - 1; row++) {
            var roadZ = globalRowZ[row + 1] - blockGap / 2;

            var edges = [hFullLeft];
            vRoadXPositions.forEach(function (rx) {
                edges.push(rx - roadWidth / 2);
                edges.push(rx + roadWidth / 2);
            });
            edges.push(hFullRight);

            for (var si = 0; si < edges.length; si += 2) {
                var segLeft = edges[si];
                var segRight = edges[si + 1];
                var segLen = segRight - segLeft;
                if (segLen < roadWidth * 0.1) continue;
                var segCenterX = (segLeft + segRight) / 2;
                var segRepeatY = Math.max(1, Math.round(segLen / roadWidth));

                var hRoad = document.createElement('a-plane');
                hRoad.setAttribute('width', roadWidth);
                hRoad.setAttribute('height', segLen);
                hRoad.setAttribute('rotation', '-90 90 0');
                hRoad.setAttribute('position', segCenterX + ' 0.001 ' + roadZ);
                hRoad.setAttribute('material', {
                    src: ROAD_MARKS_TEXTURE,
                    color: '#FFFFFF',
                    repeat: '1 ' + segRepeatY,
                    transparent: true,
                    side: 'double',
                    depthTest: true,
                    depthWrite: false
                });
                hRoad.setAttribute('class', 'mmap-building-road');
                container.appendChild(hRoad);
                _roadEntities.push(hRoad);
            }
        }

        var sortedByMcap = _buildingEntities.slice().sort(function (a, b) {
            return ((b.stock && b.stock.market_cap) || 0) - ((a.stock && a.stock.market_cap) || 0);
        });
        sortedByMcap.slice(0, BUILDINGS_LABEL_ALWAYS_TOP).forEach(function (info) {
            info.alwaysVisible = true;
        });

    }

    function _resetTo2DPosition(visualizer, wrapper) {
        var containerEl = document.getElementById('center-panel-container');
        var camera = document.getElementById('camera');

        if (wrapper && wrapper.object3D) {
            gsap.killTweensOf(wrapper.object3D.position);
            gsap.killTweensOf(wrapper.object3D.rotation);
            gsap.killTweensOf(wrapper.object3D.scale);
            wrapper.object3D.scale.set(1, 1, 1);
            wrapper.object3D.position.set(0, 0, 0);
        }
        if (containerEl && containerEl.object3D) {
            gsap.killTweensOf(containerEl.object3D.position);
        }
        if (camera && camera.object3D) {
            gsap.killTweensOf(camera.object3D.position);
        }

        if (wrapper) {
            wrapper.setAttribute('scale', '1 1 1');
            wrapper.setAttribute('position', '0 0 0');
            wrapper.setAttribute('rotation', '90 0 0');
            wrapper.emit('update-rotation', { x: 90, y: 0, z: 0 });
        }
        if (camera) {
            camera.setAttribute('position', { x: 0, y: 2.75, z: 2 });
            if (camera.object3D) camera.object3D.position.set(0, 2.75, 2);
        }
        if (visualizer) {
            visualizer.mmap2DPosition = null;
            visualizer._mmapCameraZBefore3D = undefined;
        }
        window.hasPerformedInitialZoomFit = false;
        window._mmapBuildingsExitTime = Date.now();

        var fitDelay = _wasFullscreenBefore ? 50 : 700;
        setTimeout(function () {
            window.hasPerformedInitialZoomFit = false;
            if (visualizer && visualizer.stockBars && visualizer.stockBars.size > 0 && wrapper) {
                visualizer.adjustChartToFitViewport(
                    visualizer.stockBars,
                    visualizer.heightScale,
                    visualizer.maxHeightValue,
                    visualizer.usableHeight * 0.9,
                    visualizer.zeroPlane,
                    wrapper
                );
            }
        }, fitDelay);
    }

    function _createFPSControls() {
        if (_fpsControls) return;

        var camera = document.getElementById('camera');
        var sceneEl = document.querySelector('a-scene');
        if (!camera || !sceneEl) return;

        var canvas = sceneEl.canvas;
        if (!canvas) return;

        var _wsBounds = null;
        var visualizer = _getVisualizer();
        if (visualizer && visualizer.el && visualizer.el.object3D && _worldBounds) {
            var containerObj = visualizer.el.object3D;
            var worldPos = new THREE.Vector3();
            var worldScale = new THREE.Vector3();
            containerObj.getWorldPosition(worldPos);
            containerObj.getWorldScale(worldScale);
            var s = worldScale.x || 1;
            var halfWS = _worldBounds.halfSize * s;
            var camPos = camera.object3D.position;
            _wsBounds = {
                minX: Math.min(worldPos.x - halfWS, camPos.x - 1),
                maxX: Math.max(worldPos.x + halfWS, camPos.x + 1),
                minZ: Math.min(worldPos.z - halfWS, camPos.z - 1),
                maxZ: Math.max(worldPos.z + halfWS, camPos.z + 1),
                minY: worldPos.y + _worldBounds.minHeight * s,
                maxY: worldPos.y + (_worldBounds.maxHeight + 0.3) * s
            };
        }

        var initYaw = 0;
        var initPitch = 0;
        if (visualizer && visualizer.el && visualizer.el.object3D) {
            var tgt = new THREE.Vector3();
            visualizer.el.object3D.getWorldPosition(tgt);
            var midBuildingY = tgt.y + (_worldBounds ? _worldBounds.maxHeight * 0.4 : 0.1) * (visualizer.el.object3D.parent ? visualizer.el.object3D.parent.scale.x : 1);
            var cp = camera.object3D.position;
            var dx = tgt.x - cp.x;
            var dz = tgt.z - cp.z;
            var dy = midBuildingY - cp.y;
            var distXZ = Math.sqrt(dx * dx + dz * dz);
            initYaw = Math.atan2(-dx, -dz);
            initPitch = Math.atan2(dy, distXZ);
        }

        var ctrl = {
            yaw: initYaw,
            pitch: initPitch,
            isLeftDown: false,
            lastMouseX: 0,
            lastMouseY: 0,
            keys: {},
            moveRAF: null,
            moveSpeed: 0.006,
            lookSensitivity: 0.003,
            scrollSpeed: 0.12
        };

        function clampPosition(cam) {
            if (!_wsBounds || !cam) return;
            var p = cam.object3D.position;
            p.x = Math.max(_wsBounds.minX, Math.min(_wsBounds.maxX, p.x));
            p.z = Math.max(_wsBounds.minZ, Math.min(_wsBounds.maxZ, p.z));
            p.y = Math.max(_wsBounds.minY, Math.min(_wsBounds.maxY, p.y));
        }

        function updateCameraRotation() {
            ctrl.pitch = Math.max(-Math.PI / 2 + 0.01, Math.min(Math.PI / 2 - 0.01, ctrl.pitch));
            var cam = document.getElementById('camera');
            if (cam && cam.object3D) {
                cam.object3D.rotation.set(ctrl.pitch, ctrl.yaw, 0, 'YXZ');
            }
        }

        function getForwardVector() {
            return new THREE.Vector3(-Math.sin(ctrl.yaw), 0, -Math.cos(ctrl.yaw));
        }

        function getRightVector() {
            return new THREE.Vector3(Math.cos(ctrl.yaw), 0, -Math.sin(ctrl.yaw));
        }

        function getForwardVector3D() {
            return new THREE.Vector3(
                -Math.sin(ctrl.yaw) * Math.cos(ctrl.pitch),
                Math.sin(ctrl.pitch),
                -Math.cos(ctrl.yaw) * Math.cos(ctrl.pitch)
            );
        }

        var isDragging = false;
        function onMouseDown(e) {
            if (!_isActive) return;
            if (e.button === 0) {
                ctrl.isLeftDown = true;
                ctrl.lastMouseX = e.clientX;
                ctrl.lastMouseY = e.clientY;
                isDragging = false;
                e.stopPropagation();
            }
        }

        function onMouseMove(e) {
            if (!_isActive || !ctrl.isLeftDown) return;
            e.stopPropagation();
            var dx = e.clientX - ctrl.lastMouseX;
            var dy = e.clientY - ctrl.lastMouseY;
            if (Math.abs(dx) > 2 || Math.abs(dy) > 2) {
                isDragging = true;
            }
            ctrl.yaw -= dx * ctrl.lookSensitivity;
            ctrl.pitch -= dy * ctrl.lookSensitivity;
            updateCameraRotation();
            ctrl.lastMouseX = e.clientX;
            ctrl.lastMouseY = e.clientY;
        }

        function _handleBuildingClick(e) {
            var cam = document.getElementById('camera');
            var sceneEl = document.querySelector('a-scene');
            if (!cam || !sceneEl || !sceneEl.canvas) return;

            var rect = sceneEl.canvas.getBoundingClientRect();
            var mouse = new THREE.Vector2();
            mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
            mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;

            var raycaster = new THREE.Raycaster();
            var cam3d = cam.getObject3D('camera') || cam.object3D;
            raycaster.setFromCamera(mouse, cam3d);

            var objectsToIntersect = [];
            var meshToEntityMap = new Map();
            _buildingEntities.forEach(function(info) {
                if (info.building && info.building.object3D) {
                    var mesh = info.building.getObject3D('mesh');
                    if (mesh) {
                        objectsToIntersect.push(mesh);
                        meshToEntityMap.set(mesh, info);
                    }
                }
            });

            var intersects = raycaster.intersectObjects(objectsToIntersect, true);
            if (intersects.length > 0) {
                var current = intersects[0].object;
                while (current && !meshToEntityMap.has(current)) {
                    current = current.parent;
                }
                if (current && meshToEntityMap.has(current)) {
                    var info = meshToEntityMap.get(current);
                    _showHologramPopup(info);
                    return;
                }
            }
            _hideHologramPopup();
        }

        function onMouseUp(e) {
            if (e.button === 0) {
                ctrl.isLeftDown = false;
                if (!isDragging) {
                    _handleBuildingClick(e);
                }
                e.stopPropagation();
            }
        }

        function onWheel(e) {
            if (!_isActive) return;
            e.preventDefault();
            e.stopPropagation();
            var cam = document.getElementById('camera');
            if (!cam || !cam.object3D) return;
            var fwd = getForwardVector3D();
            var dist = (e.deltaY > 0 ? -1 : 1) * ctrl.scrollSpeed;
            cam.object3D.position.x += fwd.x * dist;
            cam.object3D.position.y += fwd.y * dist;
            cam.object3D.position.z += fwd.z * dist;
            clampPosition(cam);
        }

        function onKeyDown(e) {
            if (!_isActive) return;
            ctrl.keys[e.code] = true;
            if (['Space', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].indexOf(e.code) !== -1) {
                e.preventDefault();
            }
        }
        function onKeyUp(e) {
            ctrl.keys[e.code] = false;
        }

        function moveTick() {
            if (!_isActive) { ctrl.moveRAF = null; return; }
            var cam = document.getElementById('camera');
            if (cam && cam.object3D) {
                var fwd = getForwardVector();
                var right = getRightVector();
                var speed = ctrl.moveSpeed;
                if (ctrl.keys['ShiftLeft'] || ctrl.keys['ShiftRight']) speed *= 2;

                if (ctrl.keys['KeyW'] || ctrl.keys['ArrowUp']) {
                    cam.object3D.position.x += fwd.x * speed;
                    cam.object3D.position.z += fwd.z * speed;
                }
                if (ctrl.keys['KeyS'] || ctrl.keys['ArrowDown']) {
                    cam.object3D.position.x -= fwd.x * speed;
                    cam.object3D.position.z -= fwd.z * speed;
                }
                if (ctrl.keys['KeyA'] || ctrl.keys['ArrowLeft']) {
                    cam.object3D.position.x -= right.x * speed;
                    cam.object3D.position.z -= right.z * speed;
                }
                if (ctrl.keys['KeyD'] || ctrl.keys['ArrowRight']) {
                    cam.object3D.position.x += right.x * speed;
                    cam.object3D.position.z += right.z * speed;
                }
                if (ctrl.keys['Space']) {
                    cam.object3D.position.y += speed * 0.7;
                }
                if (ctrl.keys['KeyQ']) {
                    cam.object3D.position.y -= speed * 0.7;
                }
                clampPosition(cam);
            }
            ctrl.moveRAF = requestAnimationFrame(moveTick);
        }

        function onContextMenu(e) { e.preventDefault(); }

        canvas.addEventListener('mousedown', onMouseDown, true);
        canvas.addEventListener('mousemove', onMouseMove, true);
        canvas.addEventListener('mouseup', onMouseUp, true);
        canvas.addEventListener('wheel', onWheel, { capture: true, passive: false });
        canvas.addEventListener('contextmenu', onContextMenu, true);
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('keyup', onKeyUp);

        canvas.style.cursor = 'crosshair';
        ctrl.moveRAF = requestAnimationFrame(moveTick);

        ctrl._canvas = canvas;
        ctrl._onMouseDown = onMouseDown;
        ctrl._onMouseMove = onMouseMove;
        ctrl._onMouseUp = onMouseUp;
        ctrl._onWheel = onWheel;
        ctrl._onContextMenu = onContextMenu;
        ctrl._onKeyDown = onKeyDown;
        ctrl._onKeyUp = onKeyUp;

        _fpsControls = ctrl;
        updateCameraRotation();
    }

    function _destroyFPSControls() {
        if (!_fpsControls) return;
        var ctrl = _fpsControls;
        var canvas = ctrl._canvas;

        if (ctrl.moveRAF) cancelAnimationFrame(ctrl.moveRAF);

        if (canvas) {
            canvas.removeEventListener('mousedown', ctrl._onMouseDown, true);
            canvas.removeEventListener('mousemove', ctrl._onMouseMove, true);
            canvas.removeEventListener('mouseup', ctrl._onMouseUp, true);
            canvas.removeEventListener('wheel', ctrl._onWheel, { capture: true });
            canvas.removeEventListener('contextmenu', ctrl._onContextMenu, true);
            canvas.style.cursor = '';
        }
        window.removeEventListener('keydown', ctrl._onKeyDown);
        window.removeEventListener('keyup', ctrl._onKeyUp);

        var cam = document.getElementById('camera');
        if (cam && cam.object3D) {
            cam.object3D.rotation.set(0, 0, 0);
        }

        _fpsControls = null;
    }

    return {
        isActive: isActive,
        enter: enter,
        exit: exit
    };
})();
